import React from 'react';
import { Tooltip as ReactTooltip } from "react-tooltip";

function TooltipContainer(props) {
    const { text, content, id, index, className } = props;
    
    return (
        <>
            <span data-tooltip-id={`my-tooltip-${id}-${index}`} className={`more-lines ${className}`}>
                {content}
            </span>
            <ReactTooltip
                id={`my-tooltip-${id}-${index}`}
                place="top"
                content={text}
                style={{maxWidth: '250px', wordBreak: 'break-word'}}
            />
        </>
    );
}

export default TooltipContainer;